import "./faculty.css";
import facult1 from "../../images/faculty1.png";
// import { Facultdata } from './slidedata';
import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from "../../images/post3.png";
import { Facultdata } from "../../data";
import { useState, useEffect } from "react";
import axios from "axios";

const Gallery = (props) => {
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, background: "#05A474" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, background: "#05A474" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    // dots: true,
    infinite: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    loop: true,
    margin: 10,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1320,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          autoplay: true,
          speed: 300,
          loop: true,
          margin: 10,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 2,
          infinite: true,
          autoplay: true,
          speed: 300,
          loop: true,
          margin: 10,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div className="slide-main p-0">
        <Slider {...settings}>
        {props.data.gallary.map((item) => (
                              // <div className="col-md-4">
                              //   <img
                              //     src={item.files[0]}
                              //     alt="image1"
                              //     className="gallery"
                              //   />
                              // </div>
                              <div className="main-con">
                              <div className="cards p-0 overflow-hidden shadow-none">
                                <img src={item.files[0]} alt="image1" className="gallery" />
                              </div>
                            </div>
                            ))}
          
        </Slider>
      </div>
    </>
  );
};

export default Gallery;
